import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
import { Root } from './Paper.styles';
var Paper = forwardRef(function (_a, ref) {
  var className = _a.className,
      _b = _a.rounded,
      rounded = _b === void 0 ? true : _b,
      _c = _a.shadow,
      shadow = _c === void 0 ? 'cardEasy' : _c,
      _d = _a.background,
      background = _d === void 0 ? 'primary' : _d,
      otherProps = __rest(_a, ["className", "rounded", "shadow", "background"]);

  var rootClassName = classnames(className, {
    rounded: rounded
  });
  return _jsx(Root, __assign({
    className: rootClassName,
    ref: ref,
    shadow: shadow,
    background: background
  }, otherProps));
});
export default Paper;